import { Component, Vue } from 'vue-property-decorator';
import AppConfig from './app.config';
import Accordion from './components/Accordion.vue';
import AccordionItem from './components/AccordionItem.vue';
import AdminBar from './components/AdminBar';
import Altapay from './components/Altapay.vue';
import AltapayModal from './components/AltapayModal.vue';
import AnchorNavbar from './components/AnchorNavbar.vue';
import ContactForm from './components/ContactForm.vue';
import CookieConsent from './components/CookieConsent';
import CardGridToggle from './components/CardGridToggle.vue';
import DiscountBanners from './components/DiscountBanners.vue';
import EnquireForm from './components/EnquireForm.vue';
import EnquireFormFixed from './components/EnquireFormFixed.vue';
import EnquireFormSmall from './components/EnquireFormSmall.vue';
import ExpandableContent from './components/ExpandableContent.vue';
import HorizontalSwiper from './components/HorizontalSwiper.vue';
import MainHeader from './components/MainHeader.vue';
import NavSlider from './components/NavSlider.vue';
import NavSliderItem from './components/NavSliderItem.vue';
import NavSliderViewport from './components/NavSliderViewport.vue';
import NavTab from './components/NavTab.vue';
import NewsletterForm from './components/NewsletterForm.vue';
import NewsletterRedirectForm from './components/NewsletterRedirectForm.vue';
import NpsPopup from './components/NpsPopup';
import PhotoSwipeWrapper from './components/PhotoSwipeWrapper.vue';
import PricesCalendar from './components/PricesCalendar.vue';
import ScrollTop from './components/ScrollTop';
import ShareButtons from './components/ShareButtons.vue';
import Swiper from './components/Swiper.vue';
import SwiperSlide from './components/SwiperSlide.vue';
import TourPrice from './components/TourPrice.vue';
import TourPriceDiscounts from './components/TourPriceDiscounts.vue';
import TourPricesTable from './components/TourPricesTable.vue';
import TrustPilotStars from './components/TrustPilotStars.vue';
import TrustpilotWidget from './components/TrustpilotWidget.vue';
import WorkingHours from './components/WorkingHours.vue';
import YoutubeVideo from './components/YoutubeVideo.vue';
import directives from './directives';
import { EventBus } from './helpers/bus';
import IsMobile from './helpers/isMobile';
import store from './store';

AppConfig.init();

// Install directives
Object.keys(directives).forEach((key) => {
    Vue.directive(key, directives[key]);
});

const scrollToElement = (event) => {
    const targetElementId = event.currentTarget.dataset.scrollTo;
    const targetElement = document.getElementById(targetElementId);

    const header = document.querySelector('.c-head');

    if (targetElement) {
        const topOffset = targetElement.getBoundingClientRect().top;
        let headerHeight = header ? header.getBoundingClientRect().height : 0;

        if (header) {
            const isSticky = header.classList.contains('c-head--sticky');
            if (!isSticky) {
                headerHeight = headerHeight * 2;
            }
        }

        window.scrollTo({
            top: window.pageYOffset + topOffset - headerHeight,
            behavior: 'smooth',
        });
    }

    event.preventDefault();
};

EventBus.$on('ready', (): void => {
    if (window.location.href.indexOf('#') > -1) {
        const hash = window.location.href.split('#')[1];
        const el: HTMLElement | null = document.getElementById(hash);
        if (el) {
            setTimeout(() => {
                window.scrollTo({
                    top: el.offsetTop - 100,
                    behavior: 'smooth',
                });
            }, 200);
        }
    }

    // TODO: maybe we need to remove an event before unmount
    document.querySelectorAll('[data-scroll-to]').forEach((element) => {
        element.addEventListener('click', scrollToElement);
    });
});

@Component({
    components: {
        Accordion,
        AccordionItem,
        AdminBar,
        AnchorNavbar,
        ContactForm,
        CookieConsent,
        EnquireForm,
        EnquireFormSmall,
        EnquireFormFixed,
        TourPrice,
        MainHeader,
        NavSlider,
        NavSliderItem,
        NavSliderViewport,
        NavTab,
        NewsletterForm,
        NewsletterRedirectForm,
        NpsPopup,
        WorkingHours,
        ExpandableContent,
        HorizontalSwiper,
        PhotoSwipeWrapper,
        PricesCalendar,
        ScrollTop,
        CardGridToggle,
        DiscountBanners,
        TourPriceDiscounts,
        TourPricesTable,
        TrustPilotStars,
        TrustpilotWidget,
        Altapay,
        AltapayModal,
        Swiper,
        SwiperSlide,
        YoutubeVideo,
        ShareButtons,
    },
    store,
})
class App extends Vue {

    protected handleScrollOnTabs(): void {
        const tabsWrapper = document.getElementById('tabsWrapper');
        const scrollLeftBtn = document.createElement('button');
        const scrollRightBtn = document.createElement('button');
        scrollLeftBtn.id = 'scroll-left-btn';
        scrollLeftBtn.classList.add('scroll-btn', 'scroll-left-btn');
        scrollRightBtn.id = 'scroll-right-btn';
        scrollRightBtn.classList.add('scroll-btn', 'scroll-right-btn');

        if (tabsWrapper !== null && !IsMobile.detectMobile()) {
            tabsWrapper.insertAdjacentElement('beforebegin', scrollLeftBtn);
            tabsWrapper.insertAdjacentElement('afterend', scrollRightBtn);
            const updateScrollButtons = () => {
                const isScrollableLeft = tabsWrapper.scrollLeft > 0 && tabsWrapper.scrollLeft !== 0;
                const currentWidth = tabsWrapper.clientWidth + tabsWrapper.scrollLeft;
                const isScrollableRight = tabsWrapper.scrollWidth > currentWidth && tabsWrapper.scrollWidth !== currentWidth;
                scrollLeftBtn.style.display = isScrollableLeft ? 'block' : 'none';
                scrollRightBtn.style.display = isScrollableRight ? 'block' : 'none';

                if (isScrollableLeft && isScrollableRight) {
                    scrollRightBtn.style.display = 'block';
                    scrollLeftBtn.style.display = 'block';
                } else if (isScrollableLeft) {
                    scrollLeftBtn.style.display = 'block';
                    scrollRightBtn.style.display = 'none';
                } else if (isScrollableRight) {
                    scrollRightBtn.style.display = 'block';
                    scrollLeftBtn.style.display = 'none';
                }
            };

            scrollLeftBtn.addEventListener('click', function () {
                tabsWrapper.scrollBy({
                    left: -500,
                    behavior: 'smooth',
                });
                updateScrollButtons();
            });

            scrollRightBtn.addEventListener('click', function () {
                tabsWrapper.scrollBy({
                    left: 500,
                    behavior: 'smooth',
                });
                updateScrollButtons();
            });

            tabsWrapper.addEventListener('mousemove', updateScrollButtons);
            window.addEventListener('resize', updateScrollButtons);
            updateScrollButtons();
        }
    }

    protected mounted(): void {
        this.$nextTick(function() {
            this.handleScrollOnTabs();
        });
        this.$nextTick(() => document.body.classList.remove('is-loading-page'));
        EventBus.$emit('appMounted', this);
    }
}

export default new App().$mount('#application');
